import type { JSX } from 'react'
import {
  BackgroundProps,
  LayoutProps,
  PositionProps,
  SpaceProps,
  background,
  compose,
  layout,
  position,
  space,
  BackgroundColorProps,
  color,
} from 'styled-system'
import styled, { transform, TransformProps } from 'styles/styled'
import shouldForwardProp from 'styles/shouldForwardProp'

interface CenterProps {
  center?: boolean
  verticalCenter?: boolean
  horizontalCenter?: boolean
}

const center = (props: CenterProps) => {
  if (props.verticalCenter) {
    return {
      top: '50%',
      transform: 'translate3d(0, -50%, 0)',
    }
  }

  if (props.horizontalCenter) {
    return {
      left: '50%',
      transform: 'translate3d(-50%, 0, 0)',
    }
  }

  if (!props.center) {
    return {}
  }

  return {
    top: '50%',
    left: '50%',
    transform: 'translate3d(-50%, -50%, 0)',
  }
}

export const positionContainerStyles = compose(
  background,
  color,
  layout,
  space,
  position,
  transform
)

export interface Props
  extends
    PositionProps,
    SpaceProps,
    BackgroundColorProps,
    BackgroundProps,
    LayoutProps,
    TransformProps,
    CenterProps {
  as?: keyof JSX.IntrinsicElements
}

const PositionContainer = styled('div', { shouldForwardProp })<Props>(
  center,
  ({ position = 'fixed', ...props }) =>
    positionContainerStyles({ position, ...props })
)

export default PositionContainer
